import {bffApi} from "../bffApi";
import {FunksjonalitetTilgangId} from "../../../types";

export const useHasFunctionality = (functionality: FunksjonalitetTilgangId) => {
    const userData = bffApi.endpoints.getUser.useQuery();

    if (userData.isLoading || userData.isError || !userData.data) {
        return false;
    }

    return userData.data?.tilganger.some(
        (tilgang) =>
            tilgang.navn === "Funksjonalitet" &&
            tilgang.produkter.some((produkt) => produkt.id === functionality)
    );
};
